export interface GetFiguresRequest {
    /** 任务ID */
    task_id: string;
}

export interface GetFiguresImage {
    s3_key: string;
    url: string;
    properties: {
        x: number;
        y: number;
        scale: number;
        rotation: number;
    };
}

export interface GetFiguresAnnotationAttrs {
    x: number;
    y: number;
    points: number[];
    stroke: string;
    stroke_width: string;
    stroke_type: string;
    text: string;
    padding: number;
    border_radius: number;
    text_box_fill: string;
    text_box_stroke: string;
    text_box_stroke_width: string;
}

export interface GetFiguresAnnotation {
    term_unique_id: string;
    properties: {
        type: string;
        attrs: Record<string, unknown>;
    };
}

export interface GetFiguresFigure {
    unique_id: string;
    image: GetFiguresImage;
    annotation_image_base64: string;
    annotations: GetFiguresAnnotation[];
    abstract_figure?: boolean;
}

export interface GetFiguresResponse {
    figures: GetFiguresFigure[];
}

export const GetFiguresApi = Symbol.for('GetFiguresApi');

export interface GetFiguresApi {
    getFigures(data: GetFiguresRequest): Promise<GetFiguresResponse>;
}
